import { AppPaymentService } from './../../services/AppRootService/app-payment.service';
import { NgClass } from "@angular/common";
import { Component, ElementRef, Inject, OnInit, Renderer2, ViewChild } from "@angular/core";
import { doc, docData, Firestore } from "@angular/fire/firestore";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { Router } from "@angular/router";
import { AuthService } from "@core/auth.service";
import { IonicModule } from "@ionic/angular";
import { catchError, concatMap, delay, EMPTY, filter, from, interval, map, of, Subject, switchMap, take, takeUntil, tap, timer } from "rxjs";
import { AccountRepositoryService } from "src/app/pages/account/account-repository.service";
import { SyndicateRepositoryService } from "src/app/pages/syndicate/syndicate-repository.service";
import { CashPurchaseService } from "src/app/services/cash-purchase.service";
import { GTMSegmentService } from "src/app/services/gtm-segment.service";
import { MixpanelService } from "src/app/services/mixpanel.service";

@Component({
  selector: "app-notification-pop",
  templateUrl: "./notification-pop.component.html",
  styleUrls: ["./notification-pop.component.scss"],
  standalone: true,
  imports: [IonicModule, NgClass],
})
export class NotificationPopComponent implements OnInit {
  selectedId: number = null;
  messageData: any;
  sanitizedMessage: SafeHtml;
  // slide btn start
  @ViewChild("slide_btn", { static: false }) slide_btn!: ElementRef;
  buttonText = "";
  isActivated = false;
  maxOffset = 220; // Max swipe distance
  class = "";
  isDragging = false;
  startX = 0;
  // slide btn end
  private destroySubscription$ = new Subject<void>();
  slideToBuyBtnStatus: boolean;
  statusFlag = false;
  public userId: string;
  constructor(
    private firestore: Firestore,
    private matDialogRef: MatDialogRef<NotificationPopComponent>,
    private syndicateService: SyndicateRepositoryService,
    private GTMSegment: GTMSegmentService,
    private matDialog: MatDialog,
    private authService: AuthService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private router: Router,
    private sanitizer: DomSanitizer,
    private accountService: AccountRepositoryService,
    private renderer: Renderer2,
    private cashPurchaseService: CashPurchaseService,
    private mixPanelService : MixpanelService,
    private appPaymentService: AppPaymentService
  ) {
    this.messageData = data;
    this.GTMSegment.GTMPopupInitialization("DeclineInvitaion");
    if (this.messageData?.jackpot_value) {
      this.appPaymentService.jackpotValueSignal.set(this.messageData?.jackpot_value);
    }


  }

  async ngOnInit() {
    await this.authService.getUid("NotificationPopComponent").then((uid) => {
      this.userId = uid;
    })
    const req = {
      parameter: "one_click_pay",
      condition: "one_click_pay_condition",
      feature: "one_click_pay",
      userId: this.userId,
    };
    this.authService
      .getRemoteConfig(req)
      .then((res) => {
        const remoteConfigData = res?.data;
        const showOneClick = remoteConfigData?.one_click_pay ? remoteConfigData?.one_click_pay : remoteConfigData;
        if (showOneClick) {
          this.cashPurchaseService.storedCards$.pipe(takeUntil(this.destroySubscription$)).subscribe((cards) => {
            this.slideToBuyBtnStatus = cards?.length > 0;
          });
        }
      })
      .catch((err) => {
        return err;
      });
    if (this.data?.template_type === "join_syndicate_get_points") {
      if (this.userId) {
        const path_id = `KdpTQsnyjKvgqvjItVvT`;
        const doc_data = {
          out_of_points_promotion: {
            status: true,
            updatedOn: new Date()
          }
        };
        const method = "update";
        this.authService.getV2CloudFunction("updatefirestoredoc", {
          path_id,
          doc_data,
          method,
        }).subscribe({
          error: (error) => {
            return error;
          }
        });

      }
    }
    if (
      this.messageData &&
      this.messageData?.template_data &&
      this.messageData?.template_data?.message
    ) {
      this.buttonText = this.messageData?.button_label;
      console.info(this.messageData?.destination);
      const rawHtml = this.messageData?.template_data?.message;
      this.sanitizedMessage = this.sanitizer.bypassSecurityTrustHtml(rawHtml);
    }
    this.updateInbox();
  }

  onCTA() {
    this.matDialogRef.close();
    if (this.data?.template_type === "activate_trigger_get_points" || this.data?.template_type === "activate_autorefresh_get_points" || this.data?.template_type === "join_syndicate_get_points" || this.data?.template_type === "refer_friend_get_points") {
      this.accountService.syndicatePromotion$.next(true);
    }
    if (this.messageData?.destination) {
      this.router.navigateByUrl(this.messageData?.destination);
    }
  }

  declineInvitation() {
    if (this.userId === "null" || this.userId == null || !window.navigator.onLine)
      return;
    const path_id = "i6Y4dDCDpxx6moWivjMh";
    const doc_data = { hide: true };
    const dv = { docId: this.data.psInvitation?.limb_msg_id };
    const method = "update";

    this.authService.getV2CloudFunction("updatefirestoredoc", {
      path_id,
      doc_data,
      dv,
      method,
    }).subscribe({
      error: (error) => {
        console.error("Error updating Firestore document:", error);
        return error;
      }
    });


    this.matDialogRef.close();

    this.syndicateService.updateInvitationId(this.data?.psInvitation?.invitation_id);
    this.syndicateService?.syndicateInvitedDetails$?.subscribe((doc: any) => {
      if (doc?.invited_by) {
        doc.invited_by.onSnapshot((ref) => {
          if (!ref || !ref?.id) return;
          doc["invitee"] = ref?.data();
          doc["invitee"]["id"] = ref?.id;
          this.syndicateService
            .joinSyndicateInvitation(this.data.psInvitation.ps.id, doc?.invitee.id, doc?.invitee.id, "Declined")
            .subscribe(
              (res) => {
                if (res?.status === "rejected") {
                  this.authService.getConstantsMsg(res?.error_code).then((translatedMsg) => {
                    const defaultMsg = {
                      message: {
                        line_1: "Something went wrong!",
                        line_2: "",
                      },
                      style: {
                        icon: "tick circle error.svg",
                        type: "Error",
                      },
                    }
                    this.authService.showToastMessage(translatedMsg, defaultMsg);
                  })
                    .catch((error) => {
                      return error;
                    });
                  return;
                }
                if (res && res?.response && res?.response?.status && res?.response?.status === "Declined") {
                }
              },
              (err) => {
                return err;
              }
            );
        });
      }
    });
  }

  updateInbox() {
    const limbId = this.data?.limb_id === this.data?.id ? this.data?.limb_id : this.data?.id;
    const inboxUpdate = this.data?.view_count + 1;
    const inboxViewed = inboxUpdate >= this.data?.view_capping;
    const updatePayload = {
      auto_show: false,
      viewed: true,
      view_count: inboxUpdate,
    };
    if (inboxViewed || this.data?.dismissed === true || this.data?.view_count >= this.data?.view_capping) {
      updatePayload["hide"] = true;
    }
    if (limbId && this.userId && updatePayload) {
      const path_id = "dQ2JLcXGOr5fbVp8gyIf";
      const doc_data = updatePayload;
      const dv = { docId: limbId };
      const method = "update";

      this.authService.getV2CloudFunction("updatefirestoredoc", {
        path_id,
        doc_data,
        dv,
        method,
      }).subscribe({
        error: (error) => {
          console.error("Error updating Firestore document:", error);
          return error;
        }
      });
    }
  }

  onReveal(selectedId: number) {
    this.selectedId = selectedId;
  }

  close() {
    this.matDialogRef.close();
  }

  // slide btn start ---------------------------- //
  initEvents() {
    const sliderElement = this.slide_btn.nativeElement;
    // 👉 Mobile Touch Events
    this.renderer.listen(sliderElement, "touchstart", (event: TouchEvent) => {
      this.startDrag(event.touches[0].clientX);
    });
    this.renderer.listen(sliderElement, "touchmove", (event: TouchEvent) => {
      this.drag(event.touches[0].clientX);
    });
    this.renderer.listen(sliderElement, "touchend", () => {
      this.endDrag();
    });
    // 👉 Desktop Mouse Events
    this.renderer.listen(sliderElement, "mousedown", (event: MouseEvent) => {
      this.startDrag(event.clientX);
    });
    this.renderer.listen(document, "mousemove", (event: MouseEvent) => {
      this.drag(event.clientX);
    });
    this.renderer.listen(document, "mouseup", () => {
      this.endDrag();
    });
  }
  startDrag(startPosition: number) {
    if (this.isActivated) return;
    this.isDragging = true;
    this.startX = startPosition;
  }
  drag(currentX: number) {
    if (!this.isDragging || this.isActivated) return;
    let deltaX = currentX - this.startX;
    let newX = Math.max(5, Math.min(deltaX, this.maxOffset));
    this.slide_btn.nativeElement.style.transform = `translateX(${newX}px)`;
  }
  async endDrag() {
    if (!this.isDragging) return;
    this.isDragging = false;
    const finalX = parseInt(
      this.slide_btn.nativeElement.style.transform.replace("translateX(", "").replace("px)", ""),
      10
    );
    if (finalX >= this.maxOffset - 10) {
      this.isActivated = true;
      this.buttonText = "";
      this.class = "loading-dots";

      try {
        this.cashPurchaseService.proceedToPay(this.messageData?.slide_to_buy).subscribe({
          next: (res) => {
            if (res?.errorCode === "OFFER_CAP_REACHED") {
              this.changeSlideBtnStatus();
              return;
            }

            const encryptedCustomerPurchaseId = res?.encryptedCustomerPurchaseId;
            const purchaseDetail = res?.purchaseDetail;
            if (res && encryptedCustomerPurchaseId) {
              this.pollPaymentStatus(encryptedCustomerPurchaseId, purchaseDetail);
            } else {
              const defaultMsg = {
                message: {
                  line_1: "Something went wrong!",
                  line_2: "",
                },
                style: {
                  icon: "tick circle error.svg",
                  type: "Error",
                },
              };
              this.authService.showToastMessage({}, defaultMsg);
              this.changeSlideBtnStatus();
              return;
            }
          },
          error: () => {
            const defaultMsg = {
              message: {
                line_1: "Something went wrong!",
                line_2: "",
              },
              style: {
                icon: "tick circle error.svg",
                type: "Error",
              },
            };
            this.authService.showToastMessage({}, defaultMsg);
            this.changeSlideBtnStatus();
            return;
          },
        });
      } catch (error) {
        return error;
      }
      document.querySelector(".slider-container")?.classList.add("activated");
      this.slide_btn.nativeElement.style.transform = `translateX(${this.maxOffset}px)`;
    } else {
      this.slide_btn.nativeElement.style.transform = `translateX(5px)`; // Reset position
    }
  }

  pollPaymentStatus(encryptedCustomerPurchaseId, purchaseDetail) {
    // Track one_click_pay payments
    this.mixPanelService.trackOneClickPayments("Inbox Message");

    let successHandled = false;
    const timeout$ = timer(20000);
    const pollInterval = 2000;

    const docRef = doc(this.firestore, `users/${this.userId}/customer_purchase/${encryptedCustomerPurchaseId}`);

    interval(pollInterval)
      .pipe(
        switchMap(() => {
          return docData(docRef).pipe(
            catchError((error) => {
              // Log error and return EMPTY to prevent stream breakage
              console.error('Error in pollPaymentStatus docData call:', error);
              return EMPTY;
            })
          );
        }),
        map((res) => {
          const desc = res?.payment_response_description;

          if (res?.processed_status === 2 || this.cashPurchaseService.isPaymentApproved(desc)) {
            return { success: true, data: res };
          } else if (res?.processed_status == -1 || (desc && !this.cashPurchaseService.isPaymentApproved(desc))) {
            if (!this.statusFlag) {
              this.statusFlag = true;
              return null;
            }
            return { success: false, data: res };
          }
          return null;
        }),
        filter((res) => res != null),
        take(1),
        takeUntil(timeout$),
        catchError(() => {
          return of(null);
        })
      )
      .subscribe({
        next: (res) => {
          if (res?.success) {
            successHandled = true;
            const encrypt_syndicate_id = res?.data?.api_response?.response?.encrypt_syndicate_id;
            this.handlePaymentSuccess(encrypt_syndicate_id);
          }
        },
        complete: () => {
          if (!successHandled) {
            this.close();
            this.router.navigate(["/store/checkout-try-again"], {
              queryParams: { offer_id: purchaseDetail?.offers?.offerid },
              state: purchaseDetail,
            });
            this.cashPurchaseService.purchaseDetails$.next(purchaseDetail);
          }
        },
      });
  }

  handlePaymentSuccess(encrypt_syndicate_id) {
    timer(5000)
      .pipe(
        tap(() => {
          document.querySelector(".notification-pop-wrapper")?.classList.add("activated");
          document.querySelector(".pay-successs")?.classList.add("activated");
        }),
        delay(1500),
        concatMap(() =>
          from(this.authService.getConstantsMsg("1158")).pipe(
            tap((translatedMsg) => {
              const defaultMsg = {
                message: {
                  line_1: "Congrats, you are in!",
                  line_2: "",
                },
                style: {
                  icon: "tick circle error.svg",
                  type: "Success",
                },
              };
              this.authService.showToastMessage(translatedMsg, defaultMsg);
            }),
            catchError((error) => {
              return error;
            })
          )
        ),
        delay(2000),
        tap(() => {
          document.querySelector(".notification-pop-wrapper")?.classList.remove("activated");
          document.querySelector(".pay-successs")?.classList.remove("activated");
          document.querySelector(".slider-container")?.classList.remove("activated");
          this.buttonText = this.messageData?.button_label;
          this.class = "";
          this.isActivated = false;
          this.startX = 0;
          this.slide_btn.nativeElement.style.transform = `translateX(5px)`;
          this.matDialogRef.close();
          this.router.navigate(["mainTabs/tabs/syndicate"], { state: { encrypt_syndicate_id: encrypt_syndicate_id } });
          this.cashPurchaseService.toastTrigger$.next(true);
        })
      )
      .subscribe();
  }

  changeSlideBtnStatus() {
    timer(3000)
      .pipe(
        tap(() => {
          this.slideToBuyBtnStatus = false;
          return;
        })
      )
      .subscribe();
  }
  // slide btn end ---------------------------- //
  ngAfterViewInit() {
    // slide btn start
    setTimeout(() => {
      if (!this.slide_btn) {
        return;
      }
      console.log("✅ Slider initialized:", this.slide_btn.nativeElement);
      this.initEvents();
    }, 2000);
    // slide btn end
  }
}
